import { render, staticRenderFns } from "./EditMember.vue?vue&type=template&id=245dfde8&scoped=true"
import script from "./EditMember.vue?vue&type=script&lang=js"
export * from "./EditMember.vue?vue&type=script&lang=js"
import style0 from "./EditMember.vue?vue&type=style&index=0&id=245dfde8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245dfde8",
  null
  
)

export default component.exports